import app from 'flarum/forum/app';
import showModalsOnLoad from './extenders/showModalsOnLoad';
export { default as extend } from './extend';
app.initializers.add('glowingblue-modals', () => {
  Promise.resolve().then(() => showModalsOnLoad());
});